module.exports = __webpack_public_path__ + "img/rewise-only-logo.dc7e5299.png";